import router from '../router'

function getRedirectAfterRegisterLogin(query) {
  if (!query.action) return '/profile'
  if (
    router.options.routes
      .map(x => x.path.toLowerCase())
      .includes(`/${query.action.toLowerCase()}`)
  )
    return query.action
  return '/profile'
}

export { getRedirectAfterRegisterLogin }
